<template>
  <tela-component
    :title="
      visita
        ? `Visita #${visita.id} - ${visita.nome_produtor}`
        : 'Visita não encontrada'
    "
  >
    <v-overlay v-show="gerandoRelat || visitas.carregando" :opacity="0.75" :z-index="2100">
      <v-row>
        <v-col cols="3">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-col>
        <v-col cols="9">
          <h3>{{ gerandoRelat ?  "Gerando relatório" : "Carregando visita" }}</h3>
          <p class="mt-0 caption">Aguarde alguns segundos...</p>
        </v-col>
      </v-row>
    </v-overlay>
    <!-- ALERTA SE NÃO ENCONTRAR -->
    <v-alert v-if="!visita" type="warning" text prominent class="mb-3">
      Nenhuma visita encontrada para este ID.
    </v-alert>
    <!-- INFORMAÇÕES DA VISITA -->
    <v-card v-else flat class="mb-3" rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold grey lighten-5 pt-3 pb-3">
        Informações da visita <v-spacer></v-spacer>
        <v-chip small class="mr-1"># {{ visita.id }}</v-chip>
        <chip-status-visita :visita="visita" small />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2 pb-2">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-account-cowboy-hat-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle>Produtor</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold">
              {{ visita.nome_produtor }}
              <small class="ml-1">({{ visita.matricula }})</small>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-calendar-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle>Data da visita</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold">
              {{ dataFormatada(visita.data_visita) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <template v-if="visita && configuracoes.dados">
      <v-list-item
        v-for="(checklist, i) in configuracoes.dados.opcoes_checklist"
        :key="i"
        class="mb-2 white rounded-lg"
        @click="
          btnBaixarRelat(checklist)
            ? downloadRelatorio()
            : $router.push(`${$route.path}${checklist.rota}`)
        "
      >
        <v-list-item-avatar color="primary lighten-5" size="45">
          <icone-visita-tecnica :icone="checklist.icone" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold primary--text">
            {{ checklist.descricao }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ checklist.subtitulo }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon color="primary" v-if="btnBaixarRelat(checklist)"
            >mdi-download</v-icon
          >
          <v-icon v-else>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>

      <router-view></router-view>
    </template>
    <!-- LISTA DE CHECKLIST -->
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import ChipStatusVisita from "@/components/visita-tecnica/ChipStatusVisita.vue";
import IconeVisitaTecnica from "@/components/visita-tecnica/IconeVisitaTecnica.vue";

export default {
  components: { TelaComponent, ChipStatusVisita, IconeVisitaTecnica },
  computed: mapState("visitaTecnica", [
    "configuracoes",
    "visita",
    "gerandoRelat",
    "visitas"
  ]),
  created() {
    this.carregarDaRota();
  },
  watch: {
    "$route.params.id_visita": "carregarDaRota",
    "$route.params.id": "carregarDaRota",
  },
  methods: {
    ...mapActions("visitaTecnica", ["buscarVisitas", "buscarConfiguracoes"]),
    ...mapMutations("visitaTecnica", ["resetVisita"]),
    dataFormatada(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    async carregarDaRota() {
      this.$store.state.visitaTecnica.visita = null;

      const id = this.$route.params.id_visita || this.$route.params.id;
      if (!id) return;

      if (this.configuracoes.dados == null) await this.buscarConfiguracoes();

      this.$store.state.visitaTecnica.id_visita = Number(id);
      await this.buscarVisitas();

      const itens = this.$store.state.visitaTecnica.visitas?.itens || [];
      const visitaEncontrada = itens.find((v) => v.id === Number(id));

      if (visitaEncontrada) {
        this.$store.state.visitaTecnica.visita = { ...visitaEncontrada };
      } else {
        this.$store.state.visitaTecnica.visita = null; // força alerta
      }
    },
    btnBaixarRelat(value) {
      return value.rota.includes("download");
    },
    async downloadRelatorio() {
      await this.$store.dispatch("visitaTecnica/baixarRelatorioPDF", {
        abrirEmNovaAba: true,
      });
    },
  },
  mounted() {
    //this.resetVisita();
  },
};
</script>

<style>
overlay-box {
  display: flex;
  align-items: center;
  background: rgba(20, 25, 38, 0.85);
  color: #fff;
  padding: 14px 16px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}
.overlay-title {
  font-weight: 700;
  line-height: 1.2;
}
.overlay-sub {
  font-size: 12.5px;
  opacity: 0.9;
}
</style>